interface GongLogoProps {
  size?: number;
  className?: string;
}

export function GongLogo({ size = 40, className }: GongLogoProps) {
  return (
    <div
      className={`flex items-center justify-center rounded-md ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: "#8039e9",
        padding: "8px",
      }}
    >
      <svg
        width={size - 16}
        height={size - 16}
        viewBox="0 0 150 150"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <style>{`.cls-1 { fill: white; } .cls-2 { fill: none; }`}</style>
        </defs>
        <path className="cls-2" d="M0,0H150V150H0V0Z" />
        <path
          className="cls-1"
          d="M135.56,67.69h-36.3c-2.07,0-3.65,2.12-2.91,4.1l8.74,22.62c.4,.99-.4,2.07-1.48,2.02l-11.16-.69c-.49-.05-.99,.2-1.28,.64l-8.69,12.3c-.44,.69-1.38,.94-2.12,.44l-12.84-8.74c-.49-.35-1.19-.35-1.68,0l-17.78,12.05c-1.14,.79-2.67-.3-2.27-1.63l4.94-17.73c.2-.74-.15-1.48-.89-1.78l-9.43-3.85c-.94-.4-1.23-1.53-.59-2.32l8.35-10.27c.4-.49,.44-1.23,.05-1.78l-7.01-10.12c-.64-.94-.05-2.22,1.14-2.32l10.86-.84c.79-.05,1.43-.74,1.38-1.58l-.84-15.21c-.05-1.09,1.04-1.88,2.07-1.48l13.48,5.58c.59,.25,1.28,.1,1.68-.4l9.28-10.37c.74-.84,2.07-.59,2.52,.4l5.58,14.37c.74,1.78,2.96,2.42,4.54,1.23l21.83-16.25c2.47-1.83,.89-5.78-2.17-5.33l-14.37,1.93c-.69,.1-1.33-.3-1.58-.94l-7.56-19.41c-.84-2.02-3.46-2.52-4.94-.89l-16.45,17.83c-.44,.44-1.09,.59-1.68,.35l-21.63-9.14c-1.93-.79-4.05,.54-4.15,2.67l-.79,22.32c-.05,.79-.64,1.38-1.38,1.43l-19.75,1.28c-2.32,.15-3.56,2.77-2.27,4.64l13.14,19.36c.4,.54,.35,1.28-.1,1.83l-13.33,15.31c-1.33,1.53-.79,3.9,1.09,4.69l15.31,6.62c.69,.3,1.04,1.04,.84,1.73l-9.78,38.22c-.69,2.72,2.37,4.79,4.64,3.16l36.74-26.37c.49-.35,1.19-.4,1.73,0l16.74,11.75c1.38,.99,3.26,.59,4.2-.79l10.47-16.05c.3-.49,.89-.74,1.43-.64l25.04,3.01c2.02,.3,4.05-1.38,3.31-3.26l-10.42-26.96c-.3-.74,0-1.53,.89-1.98l19.01-8.99c2.81-1.43,1.83-5.78-1.38-5.78Z"
        />
      </svg>
    </div>
  );
}
